var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],staticClass:"popover-wrapper"},[_vm._t("default"),_c('div',{ref:"popover",class:_vm.cssClasses},[_c('div',{staticClass:"arrow"}),_vm._t("popover-header"),_vm._t("popover-content")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }